import { ScoredCreditCardProduct } from '@mediaingenuity/totallymoney.types'

import {
    getFormattedAPR,
    getFormattedCurrency,
    getFormattedMonth,
} from '@utils/formatter'

export type RatesAndFeesContentType = Array<{
    title: string
    value: string | number
}>

export const createRatesAndFeesCardContent = (
    card: ScoredCreditCardProduct
) => {
    const annualInterestRatesContent: RatesAndFeesContentType = [
        {
            title: 'Balance transfers',
            value: getFormattedAPR(
                card.offerDetail.balanceTransferAER,
                card.guaranteedRate.guaranteedAPR != null &&
                    card.offerDetail.useGuaranteedAPR,
                card.guaranteedRate?.guaranteedAPR
            ),
        },
        {
            title: 'Purchases',
            value: getFormattedAPR(
                card.offerDetail.purchaseAER,
                card.guaranteedRate.guaranteedAPR != null &&
                    card.offerDetail.useGuaranteedAPR,
                card.guaranteedRate?.guaranteedAPR
            ),
        },
        {
            title: 'Cash withdrawals',
            value: getFormattedAPR(
                card.offerDetail.cashAdvanceAER,
                card.guaranteedRate.guaranteedAPR != null &&
                    card.offerDetail.useGuaranteedAPR,
                card.guaranteedRate?.guaranteedAPR
            ),
        },
    ]

    const balanceTransferContent: RatesAndFeesContentType = [
        {
            title: 'Intro rate',
            value: getFormattedAPR(
                card.offerDetail.introBalanceTransferRateAER
            ),
        },
        {
            title: 'Duration',
            value: getFormattedMonth(
                card.offerDetail.durationOfBalanceRateMonths,
                'long'
            ),
        },
        {
            title: 'Transfer fee',
            value: getFormattedAPR(card.offerDetail.introBalanceTransferFee),
        },
    ]

    const purchaseOfferContent: RatesAndFeesContentType = [
        {
            title: 'Intro rate',
            value: getFormattedAPR(card.offerDetail.introPurchaseRateAER),
        },
        {
            title: 'Duration',
            value: getFormattedMonth(
                card.offerDetail.durationOfPurchaseRateMonths,
                'long'
            ),
        },
    ]

    const otherKeyFactsContent: RatesAndFeesContentType = [
        {
            title: 'Annual fee',
            value: getFormattedCurrency(card.offerDetail.annualFee),
        },
        {
            title: 'Overseas transaction fee',
            value: getFormattedAPR(card.offerDetail.internationalCharges),
        },
    ]

    return [
        annualInterestRatesContent,
        balanceTransferContent,
        purchaseOfferContent,
        otherKeyFactsContent,
    ]
}
